import React, { useEffect, useState } from 'react';
import {
  List, ListItemButton, ListItemIcon, ListItemText, Box, Collapse,
  Typography, InputBase, IconButton
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate, useLocation } from 'react-router-dom';
import PeopleIcon from '@mui/icons-material/People';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SettingsIcon from '@mui/icons-material/Settings';
import PersonIcon from '@mui/icons-material/Person';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import BarChartIcon from '@mui/icons-material/BarChart';
import InventoryIcon from '@mui/icons-material/Inventory';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import MapIcon from '@mui/icons-material/Map';
import CategoryIcon from '@mui/icons-material/Category';
import PackageIcon from '@mui/icons-material/Inventory2';
import HomeIcon from '@mui/icons-material/Home';
import BugReportIcon from '@mui/icons-material/BugReport';
import PaymentsIcon from '@mui/icons-material/Payments';
import TelegramIcon from '@mui/icons-material/Telegram';
import SecurityIcon from '@mui/icons-material/Security';
import HistoryIcon from '@mui/icons-material/History';
import SendIcon from '@mui/icons-material/Send';
import BlockIcon from '@mui/icons-material/Block';
import LockIcon from '@mui/icons-material/Lock';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PaletteIcon from '@mui/icons-material/Palette';
import LanguageIcon from '@mui/icons-material/Language';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { useAuth } from '../../contexts/AuthContext';
import { usePermissions } from '../../hooks/usePermissions';
import axios from '../../utils/axios';

export const menuItems = [
  { 
    text: 'Главная', 
    icon: <HomeIcon />, 
    path: '/dashboard', 
    roles: ['operator', 'courier', 'curator'],
    color: '#667eea',
    permission: { resource: 'stats', action: 'view' }
  },
  { 
    text: 'Баг трекер', 
    icon: <BugReportIcon />, 
    path: '/bugtr', 
    roles: ['operator', 'curator'],
    color: '#f56565',
    permission: { resource: 'bugTracker', action: 'view' }
  },
  { 
    text: 'Управление ролями', 
    icon: <SecurityIcon />, 
    path: '/role-permissions', 
    roles: ['curator'],
    color: '#e53e3e',
    permission: { resource: 'roles', action: 'view' }
  },
  { 
    text: 'Логи активности', 
    icon: <HistoryIcon />, 
    path: '/activity-logs', 
    roles: ['curator'],
    color: '#805ad5',
    permission: { resource: 'activityLogs', action: 'view' }
  },
  { 
    text: 'Черный список', 
    icon: <BlockIcon />, 
    path: '/blacklist', 
    roles: ['operator', 'curator'],
    color: '#e53e3e',
    permission: { resource: 'blacklist', action: 'view' }
  },
  { 
    text: 'Сменить пароль', 
    icon: <LockIcon />, 
    path: '/change-password', 
    roles: ['operator', 'courier', 'curator'],
    color: '#4299e1'
  },
  {
    text: 'Точки на карте',
    icon: <MapIcon />,
    path: '/map-points',
    roles: ['operator', 'courier', 'curator'],
    color: '#0ea5e9'
  },

  { 
    text: 'Адреса', 
    icon: <LocationCityIcon />, 
    roles: ['operator', 'curator'],
    color: '#48bb78',
    permission: { resource: 'addresses', action: 'view' },
    submenu: [
      { 
        text: 'Города', 
        icon: <LocationCityIcon />, 
        path: '/cities', 
        roles: ['operator', 'curator'],
        permission: { resource: 'cities', action: 'view' }
      },
      { 
        text: 'Районы', 
        icon: <MapIcon />, 
        path: '/districts', 
        roles: ['operator', 'curator'],
        permission: { resource: 'districts', action: 'view' }
      },
      { 
        text: 'Товары', 
        icon: <CategoryIcon />, 
        path: '/products', 
        roles: ['operator', 'curator'],
        permission: { resource: 'products', action: 'view' }
      },
      { 
        text: 'Фасовка', 
        icon: <PackageIcon />, 
        path: '/packaging', 
        roles: ['operator', 'curator'],
        permission: { resource: 'packagings', action: 'view' }
      },
      { 
        text: 'Список адресов', 
        icon: <HomeIcon />, 
        path: '/addresses', 
        roles: ['operator', 'curator'],
        permission: { resource: 'addresses', action: 'view' }
      },
      {
        text: 'Остатки товаров',
        icon: <InventoryIcon />,
        path: '/inventory',
        roles: ['operator', 'curator'],
        permission: { resource: 'inventory', action: 'view' }
      },
    ]
  },
  {
    text: 'Сотрудники',
    icon: <PeopleIcon />,
    roles: ['operator', 'curator'],
    color: '#ed8936',
    permission: { resource: 'users', action: 'view' },
    submenu: [
      {
        text: 'Операторы',
        icon: <PersonIcon />,
        path: '/staff?role=operator',
        roles: ['operator', 'curator'],
        permission: { resource: 'users', action: 'view' }
      },
      {
        text: 'Курьеры',
        icon: <LocalShippingIcon />,
        path: '/staff?role=courier',
        roles: ['operator', 'curator'],
        permission: { resource: 'couriers', action: 'view' }
      },
      {
        text: 'Статистика курьеров',
        icon: <BarChartIcon />,
        path: '/courier-stats',
        roles: ['operator', 'curator'],
        permission: { resource: 'stats', action: 'courierStats' }
      },
      {
        text: 'Статистика по городам',
        icon: <LocationCityIcon />,
        path: '/city-stats',
        roles: ['operator', 'curator'],
        permission: { resource: 'stats', action: 'cityStats' }
      }
    ]
  },
  { 
    text: 'Настройки', 
    icon: <SettingsIcon />, 
    path: '/settings', 
    roles: ['operator', 'courier', 'curator'],
    color: '#718096',
    permission: { resource: 'settings', action: 'view' }
  },
  {
    text: 'Заказы',
    icon: <ShoppingCartIcon />,
    path: '/orders',
    roles: ['operator', 'curator'],
    color: '#38b2ac',
    permission: { resource: 'orders', action: 'view' }
  },
  {
    text: 'Выплаты',
    icon: <PaymentsIcon />,
    path: '/withdrawals',
    roles: ['operator', 'curator'],
    color: '#9f7aea',
    permission: { resource: 'withdrawals', action: 'view' }
  },
  {
    text: 'Telegram боты',
    privateRequestsBadge: true,
    icon: <TelegramIcon />,
    roles: ['operator', 'curator'],
    color: '#0088cc',
    permission: { resource: 'telegramBots', action: 'view' },
    submenu: [
      {
        text: 'Список ботов',
        icon: <SmartToyIcon />,
        path: '/telegram-bots',
        roles: ['operator', 'curator'],
        permission: { resource: 'telegramBots', action: 'view' }
      },
      {
        text: 'Заявки в приватные боты',
        icon: <LockIcon />,
        path: '/telegram-bots/access-requests',
        privateRequestsBadge: true,
        roles: ['operator', 'curator'],
        permission: { resource: 'telegramBots', action: 'view' }
      },
      {
        text: 'Настройки ботов',
        icon: <SettingsIcon />,
        path: '/telegram-bots-settings',
        roles: ['operator', 'curator'],
        permission: { resource: 'telegramBots', action: 'settings' }
      },
      {
        text: 'Рассылки',
        icon: <SendIcon />,
        path: '/broadcasts',
        roles: ['operator', 'curator'],
        permission: { resource: 'broadcasts', action: 'view' }
      },
      {
        text: 'Telegram каналы',
        icon: <TelegramIcon />,
        path: '/telegram-channels',
        roles: ['operator', 'curator'],
        permission: { resource: 'telegramChannels', action: 'view' }
      },
      {
        text: 'Пользователи',
        icon: <PeopleIcon />,
        path: '/telegram-users',
        roles: ['operator', 'curator'],
        permission: { resource: 'telegramUsers', action: 'view' }
      },

    ]
  },
  {
    text: 'Сайт продаж',
    icon: <StorefrontIcon />,
    roles: ['curator'],
    color: '#f56565',
    permission: { resource: 'salesSite', action: 'view' },
    submenu: [
      {
        text: 'Оформление',
        icon: <PaletteIcon />,
        path: '/sales-site/visual-editor',
        roles: ['curator'],
        permission: { resource: 'salesSite', action: 'view' }
      },
      {
        text: 'Домены',
        icon: <LanguageIcon />,
        path: '/sales-site/domains',
        roles: ['curator'],
        permission: { resource: 'salesSite', action: 'view' }
      },
      {
        text: 'Депозиты',
        icon: <AccountBalanceIcon />,
        path: '/deposit-admin',
        roles: ['curator'],
        permission: { resource: 'salesSite', action: 'view' }
      }
    ]
  },
];

const SideMenu = ({ onNavigate }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useAuth();
  const { hasPermission, loading: permissionsLoading } = usePermissions();
  const [openSubmenus, setOpenSubmenus] = useState({});
  const [query, setQuery] = useState('');
  const [pendingCount, setPendingCount] = useState(0);
  const canViewRequests = !permissionsLoading && ['operator', 'curator'].includes(currentUser?.role)
    && hasPermission('telegramBots', 'view');

  useEffect(() => {
    setPendingCount(0);
    if (!canViewRequests) return undefined;
    let active = true;
    let sequence = 0;
    const refreshCount = async () => {
      const request = ++sequence;
      try {
        const { data } = await axios.get('/telegram-bots/access-requests/count');
        if (active && request === sequence) setPendingCount(data.pendingCount);
      } catch (error) {
        if (active && request === sequence && [401, 403].includes(error.response?.status)) setPendingCount(0);
      }
    };
    const handleDecision = event => {
      sequence += 1;
      if (event.detail?.resolved) setPendingCount(count => Math.max(0, count - 1));
      refreshCount();
    };
    refreshCount();
    const interval = setInterval(refreshCount, 30000);
    window.addEventListener('private-bot-requests-changed', handleDecision);
    return () => {
      active = false;
      sequence += 1;
      clearInterval(interval);
      window.removeEventListener('private-bot-requests-changed', handleDecision);
    };
  }, [canViewRequests, currentUser?._id, currentUser?.role]);

  const renderRequestsBadge = item => item.privateRequestsBadge && canViewRequests && pendingCount > 0 && (
    <Box
      component="span"
      aria-label={`Ожидают рассмотрения: ${pendingCount}`}
      sx={{ width: 26, height: 26, flexShrink: 0, mx: 0.5, borderRadius: '50%', bgcolor: 'error.main', color: 'error.contrastText', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.65rem', fontWeight: 700 }}
    >
      {pendingCount > 99 ? '99+' : pendingCount}
    </Box>
  );

  const handleNavigation = (path) => {
    if (path) {
      navigate(path);
      onNavigate?.();
    }
  };

  const handleSubmenuToggle = (text, isOpen) => {
    setOpenSubmenus(prev => ({ ...prev, [text]: !isOpen }));
  };

  // Проверка доступа к пункту меню
  const hasAccessToMenuItem = (item) => {
    // Проверка по ролям (старая логика)
    if (!item.roles || !item.roles.includes(currentUser?.role)) {
      return false;
    }

    // Если прав еще загружаются, показываем пункт (чтобы не мигало)
    if (permissionsLoading) {
      return true;
    }

    // Проверка по правам доступа
    if (item.permission) {
      return hasPermission(item.permission.resource, item.permission.action);
    }

    // Если нет поля permission, показываем (обратная совместимость)
    return true;
  };

  // Фильтрация пунктов меню
  const filteredMenuItems = menuItems
    .map(item => ({ ...item })) // Создаем копию каждого элемента
    .filter(item => {
      if (!hasAccessToMenuItem(item)) {
        return false;
      }

      // Если есть подменю, фильтруем его
      if (item.submenu) {
        item.submenu = item.submenu.filter(subItem => hasAccessToMenuItem(subItem));
        // Если после фильтрации подменю пустое, скрываем весь пункт
        return item.submenu.length > 0;
      }

      return true;
    });

  const matchesPath = (path) => {
    if (!path) return false;
    const [pathname, search] = path.split('?');
    return location.pathname === pathname && (!search || location.search === `?${search}`);
  };
  const search = query.trim().toLocaleLowerCase('ru');
  const visibleItems = filteredMenuItems.flatMap(item => {
    if (!search || item.text.toLocaleLowerCase('ru').includes(search)) return [item];
    const submenu = item.submenu?.filter(subItem => subItem.text.toLocaleLowerCase('ru').includes(search));
    return submenu?.length ? [{ ...item, submenu }] : [];
  });
  const groups = [
    { label: 'Рабочее пространство', names: ['Главная', 'Заказы', 'Адреса', 'Точки на карте', 'Сотрудники', 'Выплаты'] },
    { label: 'Каналы продаж', names: ['Telegram боты', 'Сайт продаж'] },
    { label: 'Управление', names: ['Баг трекер', 'Черный список', 'Логи активности', 'Управление ролями', 'Настройки', 'Сменить пароль'] },
  ];
  const itemSx = {
    borderRadius: '8px', minHeight: 42, px: 1.5, mb: 0.5, color: 'text.secondary',
    '& .MuiListItemIcon-root': { minWidth: 32, color: 'inherit', '& svg': { fontSize: 19 } },
    '& .MuiListItemText-primary': { fontSize: '0.8rem', fontWeight: 550 },
    '&:hover': { color: 'text.primary', bgcolor: '#ffffff05' },
    '&.Mui-selected': {
      bgcolor: 'action.selected', color: 'primary.main',
      boxShadow: 'inset 2px 0 0 currentColor',
      '&:hover': { bgcolor: 'action.selected' },
      '& .MuiListItemIcon-root': { filter: 'drop-shadow(0 0 5px currentColor)' },
    },
    '&.Mui-focusVisible': { outline: '2px solid', outlineColor: 'primary.main', outlineOffset: 2 },
  };

  const renderMenuItem = (item) => {
    const hasSubmenu = Boolean(item.submenu?.length);
    const childActive = item.submenu?.some(subItem => matchesPath(subItem.path));
    const isSubmenuOpen = Boolean(search) || (openSubmenus[item.text] ?? childActive ?? false);
    const isActive = !hasSubmenu && matchesPath(item.path);
    return (
      <React.Fragment key={item.text}>
        <ListItemButton
          selected={isActive}
          aria-current={isActive ? 'page' : undefined}
          aria-expanded={hasSubmenu ? isSubmenuOpen : undefined}
          sx={{ ...itemSx, ...(childActive && { color: 'text.primary' }) }}
          onClick={() => hasSubmenu ? handleSubmenuToggle(item.text, isSubmenuOpen) : handleNavigation(item.path)}
        >
          <ListItemIcon>{item.icon}</ListItemIcon>
          <ListItemText primary={item.text} />
          {renderRequestsBadge(item)}
          {hasSubmenu && (isSubmenuOpen ? <ExpandLess sx={{ fontSize: 17 }} /> : <ExpandMore sx={{ fontSize: 17 }} />)}
        </ListItemButton>
        {hasSubmenu && (
          <Collapse in={isSubmenuOpen} timeout="auto" unmountOnExit>
            <List disablePadding sx={{ ml: 3, pl: 1, mb: 1, borderLeft: '1px solid', borderColor: 'divider' }}>
              {item.submenu.map(subItem => (
                <ListItemButton
                  key={subItem.text}
                  selected={matchesPath(subItem.path)}
                  aria-current={matchesPath(subItem.path) ? 'page' : undefined}
                  onClick={() => handleNavigation(subItem.path)}
                  sx={{
                    ...itemSx, minHeight: 36, px: 1,
                    '&.Mui-selected': { bgcolor: 'action.selected', color: 'primary.main', '&:hover': { bgcolor: 'action.selected' } },
                  }}
                >
                  <ListItemText primary={subItem.text} />
                  {renderRequestsBadge(subItem)}
                </ListItemButton>
              ))}
            </List>
          </Collapse>
        )}
      </React.Fragment>
    );
  };

  return (
    <Box component="nav" aria-label="Основная навигация" sx={{ flex: 1, minHeight: 0, overflowY: 'auto', px: 1.5, pb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1.25, py: 0.5, my: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: '8px', bgcolor: 'background.default', '&:focus-within': { borderColor: 'primary.main' } }}>
        <SearchIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
        <InputBase value={query} onChange={event => setQuery(event.target.value)} placeholder="Найти раздел" inputProps={{ 'aria-label': 'Найти раздел' }} sx={{ flex: 1, fontSize: '0.8rem' }} />
        {query && <IconButton size="small" aria-label="Очистить поиск" onClick={() => setQuery('')}><CloseIcon sx={{ fontSize: 15 }} /></IconButton>}
      </Box>
      {groups.map(group => {
        const items = group.names.flatMap(name => visibleItems.filter(item => item.text === name));
        return items.length > 0 && (
          <Box key={group.label} sx={{ mt: 2.5 }}>
            <Typography component="h2" variant="overline" sx={{ display: 'block', color: 'text.secondary', px: 1.5, mb: 1, fontSize: '0.59rem' }}>{group.label}</Typography>
            <List disablePadding>{items.map(renderMenuItem)}</List>
          </Box>
        );
      })}
      {visibleItems.length === 0 && <Typography variant="body2" color="text.secondary" sx={{ px: 1, py: 3 }}>Разделы не найдены</Typography>}
    </Box>
  );
};

export default SideMenu;
